import {ApiClient} from '@hconnect/apiclient'
import {StoppageEdit} from '@hconnect/common/stoppages/types/stoppage.types'
import {StoppageDto as Stoppage} from '@hconnect/common/types'
import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {prepareStoppagePayload} from '../utils'

export const useStoppageUpdate = (
  plantId: string,
  options?: UseMutationOptions<Stoppage, AxiosError, StoppageEdit>
) => {
  const queryClient = useQueryClient()

  return useMutation<Stoppage, AxiosError, StoppageEdit>({
    mutationFn: async (stoppage) => {
      const formData = await prepareStoppagePayload(stoppage, ['attachments'])
      const path = `/shifthandover/${plantId}/stoppages`

      const response = await ApiClient.axiosInstance.put<Stoppage>(path, formData)
      return response.data
    },
    ...options,
    onSuccess: (data, variables, context, mutation) => {
      void options?.onSuccess?.(data, variables, context, mutation)
      void queryClient.invalidateQueries()
    }
  })
}
